var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/social/instagram.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg viewBox=\"0 0 111.5 111.5\" class=\"c-social__instagram\" aria-labelledby=\"instagram-svg-title\" xmlns=\"http://www.w3.org/2000/svg\">\n    <title id=\"instagram-svg-title\">\n        ";
output += runtime.suppressValue((lineno = 2, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["social-instagram"])), env.opts.autoescape);
output += "\n    </title>\n\t<path d=\"M99.1 31c0 1.7-1.4 3.1-3.1 3.1H80.5c-1.7 0-3.1-1.4-3.1-3.1V15.5c0-1.7 1.4-3.1 3.1-3.1H96c1.7 0 3.1 1.4 3.1 3.1V31zm0 65c0 1.7-1.4 3.1-3.1 3.1H15.5c-1.7 0-3.1-1.4-3.1-3.1V46.4H23c-.8 3-1.3 6.1-1.3 9.3 0 18.8 15.2 34.1 34.1 34.1s34.1-15.2 34.1-34.1c0-3.2-.4-6.3-1.3-9.3h10.6V96h-.1zM55.7 34.1c12 0 21.7 9.7 21.7 21.7s-9.7 21.7-21.7 21.7S34 67.8 34 55.8s9.8-21.7 21.7-21.7zM96 0H15.5C6.9 0 0 6.9 0 15.5V96c0 8.5 6.9 15.5 15.5 15.5H96c8.5 0 15.5-6.9 15.5-15.5V15.5c0-8.6-7-15.5-15.5-15.5z\"></path>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/social/instagram.j2"] , dependencies)